import {
  initialState,
  Actions,
  State,
  GET_NOTIFICATION,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_ERROR,
  RESET_GET_NOTIFICATION,
} from "../../types/notification/one";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_NOTIFICATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_NOTIFICATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
